/**
 * Google Analytics helper functions
 * Uses REACT_APP_GA_MEASUREMENT_ID (gtag). Firebase Analytics is disabled when GA4 is set.
 */

const getGaId = () => process.env.REACT_APP_GA_MEASUREMENT_ID;

const isGaConfigured = () => {
  const gaId = getGaId();
  return gaId && gaId !== 'YOUR_GA4_MEASUREMENT_ID' && !gaId.includes('%REACT_APP_GA_MEASUREMENT_ID%');
};

export const initGA = (measurementId) => {
  if (typeof window === 'undefined') return;

  const gaId = measurementId || getGaId();
  if (!isGaConfigured() && !measurementId) {
    return;
  }

  if (!window.gtag) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
  }

  window.gtag('config', gaId, {
    page_path: window.location.pathname,
    send_page_view: true,
  });
};

export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag && isGaConfigured()) {
    window.gtag('config', getGaId(), { page_path: url });
  }
};

export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
};

export const trackConversion = (conversionName, value) => {
  trackEvent('conversion', conversionName, 'conversion', value);
};

export const trackAppointmentBooking = () => {
  trackConversion('appointment_booking', 1);
};

export const trackContactForm = () => {
  trackConversion('contact_form', 1);
};

export const trackBlogPostView = (title) => {
  trackEvent('blog_post_view', 'blog', title, 1);
};

export const trackNewsletterSignup = () => {
  trackEvent('newsletter_signup', 'engagement', 'newsletter', 1);
};

export const trackWhatsAppClick = (source) => {
  trackEvent('whatsapp_click', 'engagement', source || 'unknown', 1);
};

export const trackShopWhatsAppInquiry = (itemName) => {
  trackEvent('shop_whatsapp_inquiry', 'shop', itemName || 'unknown', 1);
};

export const trackServiceDetailView = (serviceId) => {
  trackEvent('service_detail_view', 'services', serviceId || 'unknown', 1);
};

export const trackLanguageSwitch = (language) => {
  trackEvent('language_switch', 'engagement', language, 1);
};
